import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { api, getCurrentAuthState } from '../api';

function ManagePage() {
  const { user } = getCurrentAuthState();
  const [vendors, setVendors] = useState(null);

  useEffect(() => {
    api.listVendors({}).then(page => setVendors(page.items)).catch(() => setVendors([]));
  }, []);

  if (!user || !user.isHighTrust) {
    return (
      <div style={{ padding: "24px 12px", marginTop: "100px" }}>
        <p>You don't have permission to access this page.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "24px 12px", marginTop: "100px", marginBottom: "100px" }}>
      <h1>Manage</h1>

      <h2>Vendors</h2>
      <NavLink to="/addVendor">
        <Button variant="primary" style={{ marginBottom: "24px" }}>Add Vendor</Button>
      </NavLink>

      {vendors === null && <p>Loading...</p>}
      {vendors && vendors.length === 0 && <p>No vendors yet.</p>}
      {vendors && vendors.map(v => (
        <div key={v.id} style={{ marginBottom: "12px" }}>
          <NavLink to={`/v/${v.id}`} style={{ marginRight: "12px" }}>{v.name}</NavLink>
          <NavLink to={`/addDoughnut/${v.id}`}>
            <Button size="sm" variant="outline-primary">Add Doughnut</Button>
          </NavLink>
        </div>
      ))}
    </div>
  );
}

export { ManagePage };
